import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import type { ButtonProps } from '@ps/web-fusion-components';
import { Button, ThemeProvider } from '@ps/web-fusion-components';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { Tournament } from '../../../../../types/MTT';

import { TXTCLI_Lobby } from './LobbyButton.messages.json';

interface LobbyButtonProps {
  tournament: Tournament;
  className?: string;
  size?: ButtonProps['size'];
}

const LobbyButton: React.FC<LobbyButtonProps> = ({ tournament, className, size }) => {
  const isEmbedded = useSelector(select.device.isDesktopEmbedded);
  const brandId = useSelector(select.cms.getBrandId);
  const isSisalBrand = brandId === BrandTypes.SISAL;

  const handleLobbyButtonClick = () => {
    if (isEmbedded) window.starsweb?.app?.execute(`tournament/${tournament?.id}`);
  };

  return (
    <ThemeProvider theme={isSisalBrand ? 'sisal' : 'ps-dark'}>
      <Button
        className={className}
        isDisabled={!tournament.isEnabled}
        size={size}
        width="full"
        variant="secondary"
        onClick={handleLobbyButtonClick}
      >
        <Translation {...TXTCLI_Lobby} />
      </Button>
    </ThemeProvider>
  );
};

export default LobbyButton;
